/*!
 * @license Firebase v4.6.2
 * Build: rev-cbb07d3
 * Terms: https://firebase.google.com/terms/
 */
try {
 webpackJsonpFirebase([3],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(117);


/***/ }),

/***/ 117:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ../util/dist/cjs/index.js
var cjs = __webpack_require__(0);
var cjs_default = /*#__PURE__*/__webpack_require__.n(cjs);

// CONCATENATED MODULE: ../messaging/dist/esm/src/models/errors.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var CODES = {
 AVAILABLE_IN_WINDOW: 'only-available-in-window',
 AVAILABLE_IN_SW: 'only-available-in-sw',
 SHOULD_BE_INHERITED: 'should-be-overriden',
 BAD_SENDER_ID: 'bad-sender-id',
 INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
 PERMISSION_DEFAULT: 'permission-default',
 PERMISSION_BLOCKED: 'permission-blocked',
 UNSUPPORTED_BROWSER: 'unsupported-browser',
 NOTIFICATIONS_BLOCKED: 'notifications-blocked',
 FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
 SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
 GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
 INVALID_SAVED_TOKEN: 'invalid-saved-token',
 SW_REG_REDUNDANT: 'sw-reg-redundant',
 TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
 TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
 TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
 USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
 INVALID_DELETE_TOKEN: 'invalid-delete-token',
 DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
 DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
 BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
 NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
 UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
 NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
 FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
 NO_SW_IN_REG: 'no-sw-in-reg',
 BAD_SCOPE: 'bad-scope',
 BAD_VAPID_KEY: 'bad-vapid-key',
 BAD_SUBSCRIPTION: 'bad-subscription',
 BAD_TOKEN: 'bad-token',
 BAD_PUSH_SET: 'bad-push-set',
 FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key'
};
var ERROR_MAP = (_a = {},
 _a[CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.',
 _a[CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.',
 _a[CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.',
 _a[CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
 'correctly in the options passed into firebase.initializeApp().',
 _a[CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.',
 _a[CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.',
 _a[CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
 'required to use the firebase SDK.',
 _a[CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.',
 _a[CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
 'default service worker. {$browserErrorMessage}',
 _a[CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.',
 _a[CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
 'any existing Push Subscriptions.',
 _a[CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.',
 _a[CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.',
 _a[CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}',
 _a[CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.',
 _a[CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.',
 _a[CODES.USE_SW_BEFORE_GET_TOKEN] = 'You must call useServiceWorker() before ' +
 'calling getToken() to ensure your service worker is used.',
 _a[CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
 'deleteToken(), i.e. the token from getToken().',
 _a[CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
 'be performed as the token was not found.',
 _a[CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
 'scope could not be performed as the scope was not found.',
 _a[CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.',
 _a[CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.',
 _a[CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
 'the FCM token for push messaging. Will have to resubscribe the ' +
 'user on next visit. {$message}',
 _a[CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
 'and as a result, unable to resubscribe. Will have to resubscribe the ' +
 'user on next visit.',
 _a[CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.',
 _a[CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
 'successful, there was a problem accessing the service worker itself.',
 _a[CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
 "'gcm_sender_id' value to '103953800507' to use Firebase messaging.",
 _a[CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
 'least one character.',
 _a[CODES.BAD_VAPID_KEY] = 'The public VAPID key must be a string with at ' + 'least one character.',
 _a[CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.',
 _a[CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
 'a valid token string.',
 _a[CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
 'not a valid push set string.',
 _a[CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.',
 _a);
/* harmony default export */ var errors = ({
 codes: CODES,
 map: ERROR_MAP
});
var _a;

//# sourceMappingURL=errors.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/helpers/array-buffer-to-base64.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
 var uint8Version = new Uint8Array(arrayBuffer);
 return window.btoa(String.fromCharCode.apply(null, uint8Version));
}
/* harmony default export */ var array_buffer_to_base64 = (function (arrayBuffer) {
 var base64String = toBase64(arrayBuffer);
 return base64String
 .replace(/=/g, '')
 .replace(/\+/g, '-')
 .replace(/\//g, '_');
});;

//# sourceMappingURL=array-buffer-to-base64.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/models/fcm-details.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FCM_APPLICATION_SERVER_KEY = [
 0x04,
 0x33,
 0x94,
 0xf7,
 0xdf,
 0xa1,
 0xeb,
 0xb1,
 0xdc,
 0x03,
 0xa2,
 0x5e,
 0x15,
 0x71,
 0xdb,
 0x48,
 0xd3,
 0x2e,
 0xed,
 0xed,
 0xb2,
 0x34,
 0xdb,
 0xb7,
 0x47,
 0x3a,
 0x0c,
 0x8f,
 0xc4,
 0xcc,
 0xe1,
 0x6f,
 0x3c,
 0x8c,
 0x84,
 0xdf,
 0xab,
 0xb6,
 0x66,
 0x3e,
 0xf2,
 0x0c,
 0xd4,
 0x8b,
 0xfe,
 0xe3,
 0xf9,
 0x76,
 0x2f,
 0x14,
 0x1c,
 0x63,
 0x08,
 0x6a,
 0x6f,
 0x2d,
 0xb1,
 0x1a,
 0x95,
 0xb0,
 0xce,
 0x37,
 0xc0,
 0x9c,
 0x6e
];
var SUBSCRIPTION_DETAILS = {
 userVisibleOnly: true,
 applicationServerKey: new Uint8Array(FCM_APPLICATION_SERVER_KEY)
};
/* harmony default export */ var fcm_details = ({
 ENDPOINT: 'https://fcm.googleapis.com',
 APPLICATION_SERVER_KEY: FCM_APPLICATION_SERVER_KEY,
 SUBSCRIPTION_OPTIONS: SUBSCRIPTION_DETAILS
});

//# sourceMappingURL=fcm-details.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/models/token-manager.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var FCM_TOKEN_OBJ_STORE = 'fcm_token_object_Store';
var FCM_TOKEN_DETAILS_DB_VERSION = 1;
var token_manager_TokenManager = /** @class */ (function () {
 function TokenManager() {
 this.errorFactory_ = new cjs["ErrorFactory"]('messaging', 'Messaging', errors.map);
 this.openDbPromise_ = null;
 }
 /**
 * Get the indexedDB as a promsie.
 * @private
 * @return {Promise} The IndexedDB database
 */
 TokenManager.prototype.openDatabase_ = function () {
 if (this.openDbPromise_) {
 return this.openDbPromise_;
 }
 this.openDbPromise_ = new Promise(function (resolve, reject) {
 var request = indexedDB.open(TokenManager.DB_NAME, FCM_TOKEN_DETAILS_DB_VERSION);
 request.onerror = function (event) {
 reject(event.target.error);
 };
 request.onsuccess = function (event) {
 resolve(event.target.result);
 };
 request.onupgradeneeded = function (event) {
 var db = event.target.result;
 var objectStore = db.createObjectStore(FCM_TOKEN_OBJ_STORE, {
 keyPath: 'swScope'
 });
 // Make sure the sender ID can be searched
 objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
 unique: false
 });
 objectStore.createIndex('fcmToken', 'fcmToken', {
 unique: true
 });
 };
 });
 return this.openDbPromise_;
 };
 /**
 * Close the currently open database.
 * @return {Promise} Returns the result of the promise chain.
 */
 TokenManager.prototype.closeDatabase = function () {
 var _this = this;
 if (this.openDbPromise_) {
 return this.openDbPromise_.then(function (db) {
 db.close();
 _this.openDbPromise_ = null;
 });
 }
 return Promise.resolve();
 };
 /**
 * Given a token, this method will look up the details in indexedDB.
 * @public
 * @param {string} fcmToken
 * @return {Promise} The details associated with that token.
 */
 TokenManager.prototype.getTokenDetailsFromToken = function (fcmToken) {
 return this.openDatabase_().then(function (db) {
 return new Promise(function (resolve, reject) {
 var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
 var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
 var index = objectStore.index('fcmToken');
 var request = index.get(fcmToken);
 request.onerror = function (event) {
 reject(event.target.error);
 };
 request.onsuccess = function (event) {
 resolve(event.target.result);
 };
 });
 });
 };
 TokenManager.prototype.getTokenDetailsFromSWScope_ = function (swScope) {
 return this.openDatabase_().then(function (db) {
 return new Promise(function (resolve, reject) {
 var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
 var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
 var scopeRequest = objectStore.get(swScope);
 scopeRequest.onerror = function (event) {
 reject(event.target.error);
 };
 scopeRequest.onsuccess = function (event) {
 resolve(event.target.result);
 };
 });
 });
 };
 TokenManager.prototype.getAllTokenDetailsForSenderId_ = function (senderId) {
 return this.openDatabase_().then(function (db) {
 return new Promise(function (resolve, reject) {
 var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
 var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
 var senderIdTokens = [];
 var cursorRequest = objectStore.openCursor();
 cursorRequest.onerror = function (event) {
 reject(event.target.error);
 };
 cursorRequest.onsuccess = function (event) {
 var cursor = event.target.result;
 if (cursor) {
 if (cursor.value['fcmSenderId'] === senderId) {
 senderIdTokens.push(cursor.value);
 }
 cursor.continue();
 }
 else {
 resolve(senderIdTokens);
 }
 };
 });
 });
 };
 /**
 * Given a PushSubscription and messagingSenderId, get an FCM token.
 * @public
 * @param {string} senderId The 'messagingSenderId' to tie the token to.
 * @param {PushSubscription} subscription The PushSusbcription to "federate".
 * @param {string=} pushSet If defined this will swap the subscription for
 * matching FCM token.
 * @return {Promise} Returns the FCM token to be used in place
 * of the PushSubscription.
 */
 TokenManager.prototype.subscribeToFCM = function (senderId, subscription, pushSet) {
 var _this = this;
 var p256dh = array_buffer_to_base64(subscription['getKey']('p256dh'));
 var auth = array_buffer_to_base64(subscription['getKey']('auth'));
 var fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
 ("endpoint=" + subscription.endpoint + "&") +
 ("encryption_key=" + p256dh + "&") +
 ("encryption_auth=" + auth);
 if (pushSet) {
 fcmSubscribeBody += "&pushSet=" + pushSet;
 }
 var headers = new Headers();
 headers.append('Content-Type', 'application/x-www-form-urlencoded');
 var subscribeOptions = {
 method: 'POST',
 headers: headers,
 body: fcmSubscribeBody
 };
 return fetch(fcm_details.ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)
 .then(function (response) { return response.json(); })
 .then(function (response) {
 var fcmTokenResponse = response;
 if (fcmTokenResponse['error']) {
 var message = fcmTokenResponse['error']['message'];
 throw _this.errorFactory_.create(errors.codes.TOKEN_SUBSCRIBE_FAILED, {
 message: message
 });
 }
 if (!fcmTokenResponse['token']) {
 throw _this.errorFactory_.create(errors.codes.TOKEN_SUBSCRIBE_NO_TOKEN);
 }
 if (!fcmTokenResponse['pushSet']) {
 throw _this.errorFactory_.create(errors.codes.TOKEN_SUBSCRIBE_NO_PUSH_SET);
 }
 return {
 token: fcmTokenResponse['token'],
 pushSet: fcmTokenResponse['pushSet']
 };
 });
 };
 /**
 * Checks the that fields in the PushSubscription are equivalent to the
 * details stores in the masterTokenDetails.
 * @private
 * @param {PushSubscription} subscription The push subscription we expect
 * the master token to match.
 * @param {Object} masterTokenDetails The saved details we wish to compare
 * with the PushSubscription
 * @return {boolean} true if the subscription and token details are
 * equivalent.
 */
 TokenManager.prototype.isSameSubscription_ = function (subscription, masterTokenDetails) {
 // getKey() isn't defined in the PushSubscription externs file, hence
 // subscription['getKey']('').
 return (subscription.endpoint === masterTokenDetails['endpoint'] &&
 array_buffer_to_base64(subscription['getKey']('auth')) ===
 masterTokenDetails['auth'] &&
 array_buffer_to_base64(subscription['getKey']('p256dh')) ===
 masterTokenDetails['p256dh']);
 };
 /**
 * Save the details for the fcm token for re-use at a later date.
 * @private
 * @param {string} senderId The 'messagingSenderId' used for this project
 * @param {ServiceWorkerRegistration} swRegistration The service worker
 * used to subscribe the user for web push
 * @param {PushSubscription} subscription The push subscription passed to
 * FCM for the current token.
 * @param {string} fcmToken The FCM token currently used on this
 * device.
 * @param {string} fcmPushSet The FCM push tied to the fcm token.
 * @return {Promise}
 */
 TokenManager.prototype.saveTokenDetails_ = function (senderId, swRegistration, subscription, fcmToken, fcmPushSet) {
 var details = {
 swScope: swRegistration.scope,
 endpoint: subscription.endpoint,
 auth: array_buffer_to_base64(subscription['getKey']('auth')),
 p256dh: array_buffer_to_base64(subscription['getKey']('p256dh')),
 fcmToken: fcmToken,
 fcmPushSet: fcmPushSet,
 fcmSenderId: senderId
 };
 return this.openDatabase_().then(function (db) {
 return new Promise(function (resolve, reject) {
 var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
 var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
 var request = objectStore.put(details);
 request.onerror = function (event) {
 reject(event.target.error);
 };
 request.onsuccess = function (event) {
 resolve();
 };
 });
 });
 };
 /**
 * Returns the saved FCM Token if one is available and still valid,
 * otherwise `null` is returned.
 * @param {string} senderId This should be the sender ID associated with the
 * FCM Token being retrieved.
 * @param {ServiceWorkerRegistration} swRegistration Registration to be used
 * to subscribe the user to push.
 * @return {Promise | Promise} Returns the saved FCM Token if
 * avilable and valid.
 * @export
 */
 TokenManager.prototype.getSavedToken = function (senderId, swRegistration) {
 var _this = this;
 if (!(swRegistration instanceof ServiceWorkerRegistration)) {
 return Promise.reject(this.errorFactory_.create(errors.codes.SW_REGISTRATION_EXPECTED));
 }
 if (typeof senderId !== 'string' || senderId.length === 0) {
 return Promise.reject(this.errorFactory_.create(errors.codes.BAD_SENDER_ID));
 }
 return this.getAllTokenDetailsForSenderId_(senderId)
 .then(function (allTokenDetails) {
 if (allTokenDetails.length === 0) {
 return;
 }
 var index = allTokenDetails.findIndex(function (tokenDetails) {
 return (swRegistration.scope === tokenDetails['swScope'] &&
 senderId === tokenDetails['fcmSenderId']);
 });
 if (index === -1) {
 return;
 }
 return allTokenDetails[index];
 })
 .then(function (tokenDetails) {
 if (!tokenDetails) {
 return;
 }
 return swRegistration.pushManager
 .getSubscription()
 .catch(function (err) {
 throw _this.errorFactory_.create(errors.codes.GET_SUBSCRIPTION_FAILED);
 })
 .then(function (subscription) {
 if (subscription &&
 _this.isSameSubscription_(subscription, tokenDetails)) {
 return tokenDetails['fcmToken'];
 }
 });
 });
 };
 /**
 * Creates a new FCM token.
 */
 TokenManager.prototype.createToken = function (senderId, swRegistration) {
 var _this = this;
 if (typeof senderId !== 'string' || senderId.length === 0) {
 return Promise.reject(this.errorFactory_.create(errors.codes.BAD_SENDER_ID));
 }
 if (!(swRegistration instanceof ServiceWorkerRegistration)) {
 return Promise.reject(this.errorFactory_.create(errors.codes.SW_REGISTRATION_EXPECTED));
 }
 // Check for existing subscription first
 var subscription;
 var fcmTokenDetails;
 return swRegistration.pushManager
 .getSubscription()
 .then(function (subscription) {
 if (subscription) {
 return subscription;
 }
 return swRegistration.pushManager.subscribe(fcm_details.SUBSCRIPTION_OPTIONS);
 })
 .then(function (sub) {
 subscription = sub;
 return _this.subscribeToFCM(senderId, subscription);
 })
 .then(function (tokenDetails) {
 fcmTokenDetails = tokenDetails;
 return _this.saveTokenDetails_(senderId, swRegistration, subscription, fcmTokenDetails['token'], fcmTokenDetails['pushSet']);
 })
 .then(function () { return fcmTokenDetails['token']; });
 };
 /**
 * This method deletes details of the current FCM token.
 * It's returning a promise in case we need to move to an async
 * method for deleting at a later date.
 * @param {string} token Token to be deleted
 * @return {Promise} Resolves once the FCM token details have been
 * deleted and returns the deleted details.
 */
 TokenManager.prototype.deleteToken = function (token) {
 var _this = this;
 if (typeof token !== 'string' || token.length === 0) {
 return Promise.reject(this.errorFactory_.create(errors.codes.INVALID_DELETE_TOKEN));
 }
 return this.getTokenDetailsFromToken(token).then(function (details) {
 if (!details) {
 throw _this.errorFactory_.create(errors.codes.DELETE_TOKEN_NOT_FOUND);
 }
 return _this.openDatabase_().then(function (db) {
 return new Promise(function (resolve, reject) {
 var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
 var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
 var request = objectStore.delete(details['swScope']);
 request.onerror = function (event) {
 reject(event.target.error);
 };
 request.onsuccess = function (event) {
 if (event.target.result === 0) {
 reject(_this.errorFactory_.create(errors.codes.FAILED_TO_DELETE_TOKEN));
 return;
 }
 resolve(details);
 };
 });
 });
 });
 };
 return TokenManager;
}());
/* harmony default export */ var token_manager = (token_manager_TokenManager);

//# sourceMappingURL=token-manager.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/models/notification-permission.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ var notification_permission = ({
 granted: 'granted',
 default: 'default',
 denied: 'denied'
});

//# sourceMappingURL=notification-permission.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/controllers/controller-interface.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var SENDER_ID_OPTION_NAME = 'messagingSenderId';
var controller_interface_ControllerInterface = /** @class */ (function () {
 /**
 * An interface of the Messaging Service API
 * @param {!firebase.app.App} app
 */
 function ControllerInterface(app) {
 var _this = this;
 this.errorFactory_ = new cjs["ErrorFactory"]('messaging', 'Messaging', errors.map);
 if (!app.options[SENDER_ID_OPTION_NAME] ||
 typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
 throw this.errorFactory_.create(errors.codes.BAD_SENDER_ID);
 }
 this.messagingSenderId_ = app.options[SENDER_ID_OPTION_NAME];
 this.tokenManager_ = new token_manager();
 this.app = app;
 this.INTERNAL = {};
 this.INTERNAL.delete = function () { return _this.delete; };
 }
 /**
 * @export
 * @return {Promise | Promise} Returns a promise that
 * resolves to an FCM token.
 */
 ControllerInterface.prototype.getToken = function () {
 var _this = this;
 // Check with permissions
 var currentPermission = this.getNotificationPermission_();
 if (currentPermission !== notification_permission.granted) {
 if (currentPermission === notification_permission.denied) {
 return Promise.reject(this.errorFactory_.create(errors.codes.NOTIFICATIONS_BLOCKED));
 }
 // We must wait for permission to be granted
 return Promise.resolve(null);
 }
 return this.getSWRegistration_().then(function (registration) {
 return _this.tokenManager_
 .getSavedToken(_this.messagingSenderId_, registration)
 .then(function (token) {
 if (token) {
 return token;
 }
 return _this.tokenManager_.createToken(_this.messagingSenderId_, registration);
 });
 });
 };
 /**
 * This method deletes tokens that the token manager looks after and then
 * unregisters the push subscription if it exists.
 * @export
 * @param {string} token
 * @return {Promise}
 */
 ControllerInterface.prototype.deleteToken = function (token) {
 var _this = this;
 return this.tokenManager_.deleteToken(token).then(function () {
 return _this.getSWRegistration_()
 .then(function (registration) {
 if (registration) {
 return registration.pushManager.getSubscription();
 }
 })
 .then(function (subscription) {
 if (subscription) {
 return subscription.unsubscribe();
 }
 });
 });
 };
 ControllerInterface.prototype.getSWRegistration_ = function () {
 throw this.errorFactory_.create(errors.codes.SHOULD_BE_INHERITED);
 };
 //
 // The following methods should only be available in the window.
 //
 ControllerInterface.prototype.requestPermission = function () {
 throw this.errorFactory_.create(errors.codes.AVAILABLE_IN_WINDOW);
 };
 /**
 * @export
 * @param {!ServiceWorkerRegistration} registration
 */
 ControllerInterface.prototype.useServiceWorker = function (registration) {
 throw this.errorFactory_.create(errors.codes.AVAILABLE_IN_WINDOW);
 };
 /**
 * @export
 * @param {!firebase.Observer|function(*)} nextOrObserver
 * @param {function(!Error)=} optError
 * @param {function()=} optCompleted
 * @return {!function()}
 */
 ControllerInterface.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
 throw this.errorFactory_.create(errors.codes.AVAILABLE_IN_WINDOW);
 };
 /**
 * @export
 * @param {!firebase.Observer|function()} nextOrObserver An observer object
 * or a function triggered on token refresh.
 * @param {function(!Error)=} optError Optional A function
 * triggered on token refresh error.
 * @param {function()=} optCompleted Optional function triggered when the
 * observer is removed.
 * @return {!function()} The unsubscribe function for the observer.
 */
 ControllerInterface.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
 throw this.errorFactory_.create(errors.codes.AVAILABLE_IN_WINDOW);
 };
 //
 // The following methods are used by the service worker only.
 //
 /**
 * @export
 * @param {function(Object)} callback
 */
 ControllerInterface.prototype.setBackgroundMessageHandler = function (callback) {
 throw this.errorFactory_.create(errors.codes.AVAILABLE_IN_SW);
 };
 //
 // The following methods are used by the service themselves and not exposed
 // publicly or not expected to be used by developers.
 //
 /**
 * This method is required to adhere to the Firebase interface.
 * It closes any currently open indexdb database connections.
 */
 ControllerInterface.prototype.delete = function () {
 return this.tokenManager_.closeDatabase();
 };
 /**
 * Returns the current Notification Permission state.
 * @private
 * @return {string} The currenct permission state.
 */
 ControllerInterface.prototype.getNotificationPermission_ = function () {
 return Notification.permission;
 };
 /**
 * @protected
 * @returns {TokenManager}
 */
 ControllerInterface.prototype.getTokenManager = function () {
 return this.tokenManager_;
 };
 return ControllerInterface;
}());
/* harmony default export */ var controller_interface = (controller_interface_ControllerInterface);

//# sourceMappingURL=controller-interface.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/models/worker-page-message.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// These fields are strings to prevent closure from thinking goog.getMsg
// should be used to initialise the values
var PARAMS = {
 TYPE_OF_MSG: 'firebase-messaging-msg-type',
 DATA: 'firebase-messaging-msg-data'
};
// This value isn't using the TYPE_OF_MSG short hand as closure
// expects the variable to be defined via goog.getMsg
var msgType = {
 PUSH_MSG_RECEIVED: 'push-msg-received',
 NOTIFICATION_CLICKED: 'notification-clicked'
};
var createNewMsg = function (msgType, msgData) {
 var message = (_a = {},
 _a[PARAMS.TYPE_OF_MSG] = msgType,
 _a[PARAMS.DATA] = msgData,
 _a);
 return message;
 var _a;
};
/* harmony default export */ var worker_page_message = ({
 PARAMS: PARAMS,
 TYPES_OF_MSG: msgType,
 createNewMsg: createNewMsg
});

//# sourceMappingURL=worker-page-message.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/models/default-sw.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ var default_sw = ({
 path: '/firebase-messaging-sw.js',
 scope: '/firebase-cloud-messaging-push-scope'
});

//# sourceMappingURL=default-sw.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/controllers/window-controller.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();






var window_controller_WindowController = /** @class */ (function (_super) {
 __extends(WindowController, _super);
 /**
 * A service that provides a MessagingService instance.
 * @param {!firebase.app.App} app
 */
 function WindowController(app) {
 var _this = _super.call(this, app) || this;
 /**
 * @private
 * @type {ServiceWorkerRegistration}
 */
 _this.registrationToUse_;
 /**
 * @private
 * @type {Promise}
 */
 _this.manifestCheckPromise_;
 /**
 * @private
 * @type {firebase.Observer}
 */
 _this.messageObserver_ = null;
 /**
 * @private {!firebase.Subscribe} The subscribe function to the onMessage
 * observer.
 */
 _this.onMessage_ = Object(cjs["createSubscribe"])(function (observer) {
 _this.messageObserver_ = observer;
 });
 /**
 * @private
 * @type {firebase.Observer}
 */
 _this.tokenRefreshObserver_ = null;
 _this.onTokenRefresh_ = Object(cjs["createSubscribe"])(function (observer) {
 _this.tokenRefreshObserver_ = observer;
 });
 _this.setupSWMessageListener_();
 return _this;
 }
 /**
 * This method returns an FCM token if it can be generated.
 * The return promise will reject if the browser doesn't support
 * FCM, if permission is denied for notifications or it's not
 * possible to generate a token.
 * @export
 * @return {Promise | Promise} Returns a promise the
 * resolves to an FCM token or null if permission isn't granted.
 */
 WindowController.prototype.getToken = function () {
 var _this = this;
 // Check that the required API's are available
 if (!this.isSupported_()) {
 return Promise.reject(this.errorFactory_.create(errors.codes.UNSUPPORTED_BROWSER));
 }
 return this.manifestCheck_().then(function () {
 return _super.prototype.getToken.call(_this);
 });
 };
 /**
 * The method checks that a manifest is defined and has the correct GCM
 * sender ID.
 * @private
 * @return {Promise} Returns a promise that resolves if the manifest matches
 * our required sender ID
 */
 WindowController.prototype.manifestCheck_ = function () {
 var _this = this;
 if (this.manifestCheckPromise_) {
 return this.manifestCheckPromise_;
 }
 var manifestTag = document.querySelector('link[rel="manifest"]');
 if (!manifestTag) {
 this.manifestCheckPromise_ = Promise.resolve();
 }
 else {
 this.manifestCheckPromise_ = fetch(manifestTag.href)
 .then(function (response) {
 return response.json();
 })
 .catch(function () {
 // If the download or parsing fails allow check.
 // We only want to error if we KNOW that the gcm_sender_id is incorrect.
 return Promise.resolve();
 })
 .then(function (manifestContent) {
 if (!manifestContent) {
 return;
 }
 if (!manifestContent['gcm_sender_id']) {
 return;
 }
 if (manifestContent['gcm_sender_id'] !== '103953800507') {
 throw _this.errorFactory_.create(errors.codes.INCORRECT_GCM_SENDER_ID);
 }
 });
 }
 return this.manifestCheckPromise_;
 };
 /**
 * Request permission if it is not currently granted
 * @export
 * @returns {Promise} Resolves if the permission was granted, otherwise
 * rejects
 */
 WindowController.prototype.requestPermission = function () {
 var _this = this;
 if (Notification.permission === notification_permission.granted) {
 return Promise.resolve();
 }
 return new Promise(function (resolve, reject) {
 var managePermissionResult = function (result) {
 if (result === notification_permission.granted) {
 return resolve();
 }
 else if (result === notification_permission.denied) {
 return reject(_this.errorFactory_.create(errors.codes.PERMISSION_BLOCKED));
 }
 else {
 return reject(_this.errorFactory_.create(errors.codes.PERMISSION_DEFAULT));
 }
 };
 // The Notification.requestPermission API was changed to
 // return a promise so now have to handle both in case
 // browsers stop support callbacks for promised version
 var permissionPromise = Notification.requestPermission(function (result) {
 if (permissionPromise) {
 // Let the promise manage this
 return;
 }
 managePermissionResult(result);
 });
 if (permissionPromise) {
 // Prefer the promise version as it's the future API.
 permissionPromise.then(managePermissionResult);
 }
 });
 };
 /**
 * This method allows a developer to override the default service worker and
 * instead use a custom service worker.
 * @export
 * @param {!ServiceWorkerRegistration} registration The service worker
 * registration that should be used to receive the push messages.
 */
 WindowController.prototype.useServiceWorker = function (registration) {
 if (!(registration instanceof ServiceWorkerRegistration)) {
 throw this.errorFactory_.create(errors.codes.SW_REGISTRATION_EXPECTED);
 }
 if (typeof this.registrationToUse_ !== 'undefined') {
 throw this.errorFactory_.create(errors.codes.USE_SW_BEFORE_GET_TOKEN);
 }
 this.registrationToUse_ = registration;
 };
 /**
 * @export
 * @param {!firebase.Observer|function(*)} nextOrObserver An observer object
 * or a function triggered on message.
 * @param {function(!Error)=} optError Optional A function triggered on
 * message error.
 * @param {function()=} optCompleted Optional function triggered when the
 * observer is removed.
 * @return {!function()} The unsubscribe function for the observer.
 */
 WindowController.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
 return this.onMessage_(nextOrObserver, optError, optCompleted);
 };
 /**
 * @export
 * @param {!firebase.Observer|function()} nextOrObserver An observer object
 * or a function triggered on token refresh.
 * @param {function(!Error)=} optError Optional A function
 * triggered on token refresh error.
 * @param {function()=} optCompleted Optional function triggered when the
 * observer is removed.
 * @return {!function()} The unsubscribe function for the observer.
 */
 WindowController.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
 return this.onTokenRefresh_(nextOrObserver, optError, optCompleted);
 };
 /**
 * Given a registration, wait for the service worker it relates to
 * become activer
 * @private
 * @param {ServiceWorkerRegistration} registration Registration to wait
 * for service worker to become active
 * @return {Promise} Wait for service worker
 * registration to become active
 */
 WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
 var _this = this;
 var serviceWorker = registration.installing || registration.waiting || registration.active;
 return new Promise(function (resolve, reject) {
 if (!serviceWorker) {
 // This is a rare scenario but has occured in firefox
 reject(_this.errorFactory_.create(errors.codes.NO_SW_IN_REG));
 return;
 }
 // Because the Promise function is called on next tick there is a
 // small chance that the worker became active or redundant already.
 if (serviceWorker.state === 'activated') {
 resolve(registration);
 return;
 }
 if (serviceWorker.state === 'redundant') {
 reject(_this.errorFactory_.create(errors.codes.SW_REG_REDUNDANT));
 return;
 }
 var stateChangeListener = function () {
 if (serviceWorker.state === 'activated') {
 resolve(registration);
 }
 else if (serviceWorker.state === 'redundant') {
 reject(_this.errorFactory_.create(errors.codes.SW_REG_REDUNDANT));
 }
 else {
 // Return early and wait to next state change
 return;
 }
 serviceWorker.removeEventListener('statechange', stateChangeListener);
 };
 serviceWorker.addEventListener('statechange', stateChangeListener);
 });
 };
 /**
 * This will regiater the default service worker and return the registration
 * @private
 * @return {Promise} The service worker
 * registration to be used for the push service.
 */
 WindowController.prototype.getSWRegistration_ = function () {
 var _this = this;
 if (this.registrationToUse_) {
 return this.waitForRegistrationToActivate_(this.registrationToUse_);
 }
 // Make the registration null so we know useServiceWorker will not
 // use a new service worker as registrationToUse_ is no longer undefined
 this.registrationToUse_ = null;
 return navigator.serviceWorker
 .register(default_sw.path, {
 scope: default_sw.scope
 })
 .catch(function (err) {
 throw _this.errorFactory_.create(errors.codes.FAILED_DEFAULT_REGISTRATION, {
 browserErrorMessage: err.message
 });
 })
 .then(function (registration) {
 return _this.waitForRegistrationToActivate_(registration).then(function () {
 _this.registrationToUse_ = registration;
 // We update after activation due to an issue with Firefox v49 where
 // a race condition occassionally causes the service work to not
 // install
 registration.update();
 return registration;
 });
 });
 };
 /**
 * This method will set up a message listener to handle
 * events from the service worker that should trigger
 * events in the page.
 *
 * @private
 */
 WindowController.prototype.setupSWMessageListener_ = function () {
 var _this = this;
 if (!('serviceWorker' in navigator)) {
 return;
 }
 navigator.serviceWorker.addEventListener('message', function (event) {
 if (!event.data || !event.data[worker_page_message.PARAMS.TYPE_OF_MSG]) {
 // Not a message from FCM
 return;
 }
 var workerPageMessage = event.data;
 switch (workerPageMessage[worker_page_message.PARAMS.TYPE_OF_MSG]) {
 case worker_page_message.TYPES_OF_MSG.PUSH_MSG_RECEIVED:
 case worker_page_message.TYPES_OF_MSG.NOTIFICATION_CLICKED:
 var pushMessage = workerPageMessage[worker_page_message.PARAMS.DATA];
 _this.messageObserver_.next(pushMessage);
 break;
 default:
 // Noop.
 break;
 }
 }, false);
 };
 /**
 * Checks to see if the required API's are valid or not.
 * @private
 * @return {boolean} Returns true if the desired APIs are available.
 */
 WindowController.prototype.isSupported_ = function () {
 return ('serviceWorker' in navigator &&
 'PushManager' in window &&
 'Notification' in window &&
 'fetch' in window &&
 ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
 PushSubscription.prototype.hasOwnProperty('getKey'));
 };
 return WindowController;
}(controller_interface));
/* harmony default export */ var window_controller = (window_controller_WindowController);

//# sourceMappingURL=window-controller.js.map

// CONCATENATED MODULE: ../messaging/dist/esm/src/controllers/sw-controller.js
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var sw_controller___extends = (this && this.__extends) || (function () {
 var extendStatics = Object.setPrototypeOf ||
 ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
 function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
 return function (d, b) {
 extendStatics(d, b);
 function __() { this.constructor = d; }
 d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
 };
})();




var FCM_MSG = 'FCM_MSG';
var sw_controller_SWController = /** @class */ (function (_super) {
 sw_controller___extends(SWController, _super);
 function SWController(app) {
 var _this = _super.call(this, app) || this;
 self.addEventListener('push', function (e) { return _this.onPush_(e); }, false);
 self.addEventListener('pushsubscriptionchange', function (e) { return _this.onSubChange_(e); }, false);
 self.addEventListener('notificationclick', function (e) { return _this.onNotificationClick_(e); }, false);
 /**
 * @private
 * @type {function(Object)|null}
 */
 _this.bgMessageHandler_ = null;
 return _this;
 }
 /**
 * A handler for push events that shows notifications based on the content of
 * the payload.
 *
 * The payload must be a JSON-encoded Object with a `notification` key. The
 * value of the `notification` property will be used as the NotificationOptions
 * object passed to showNotification. Additionally, the `title` property of the
 * notification object will be used as the title.
 *
 * If there is no notification data in the payload then no notification will be
 * shown.
 * @private
 */
 SWController.prototype.onPush_ = function (event) {
 var _this = this;
 var msgPayload;
 try {
 msgPayload = event.data.json();
 }
 catch (err) {
 // Not JSON so not an FCM message
 return;
 }
 var handleMsgPromise = this.hasVisibleClients_().then(function (hasVisibleClients) {
 if (hasVisibleClients) {
 // Do not need to show a notification.
 if (msgPayload.notification || _this.bgMessageHandler_) {
 // Send to page
 return _this.sendMessageToWindowClients_(msgPayload);
 }
 return;
 }
 var notificationDetails = _this.getNotificationData_(msgPayload);
 if (notificationDetails) {
 var notificationTitle = notificationDetails.title || '';
 return self.registration.showNotification(notificationTitle, notificationDetails);
 }
 else if (_this.bgMessageHandler_) {
 return _this.bgMessageHandler_(msgPayload);
 }
 });
 event.waitUntil(handleMsgPromise);
 };
 /**
 * @private
 */
 SWController.prototype.onSubChange_ = function (event) {
 var _this = this;
 var promiseChain = this.getToken().then(function (token) {
 if (!token) {
 // We can't resubscribe if we don't have an FCM token for this scope.
 throw _this.errorFactory_.create(errors.codes.NO_FCM_TOKEN_FOR_RESUBSCRIBE);
 }
 var tokenDetails = null;
 var tokenManager = _this.getTokenManager();
 return tokenManager
 .getTokenDetailsFromToken(token)
 .then(function (details) {
 tokenDetails = details;
 if (!tokenDetails) {
 throw _this.errorFactory_.create(errors.codes.INVALID_SAVED_TOKEN);
 }
 // Attempt to get a new subscription
 return self.registration.pushManager.subscribe(fcm_details.SUBSCRIPTION_OPTIONS);
 })
 .then(function (newSubscription) {
 // Send new subscription to FCM.
 return tokenManager.subscribeToFCM(tokenDetails.fcmSenderId, newSubscription, tokenDetails.fcmPushSet);
 })
 .catch(function (err) {
 // The best thing we can do is log this to the terminal so
 // developers might notice the error.
 return tokenManager.deleteToken(tokenDetails.fcmToken).then(function () {
 throw _this.errorFactory_.create(errors.codes.UNABLE_TO_RESUBSCRIBE, {
 message: err
 });
 });
 });
 });
 event.waitUntil(promiseChain);
 };
 /**
 * @private
 */
 SWController.prototype.onNotificationClick_ = function (event) {
 var _this = this;
 if (!(event.notification &&
 event.notification.data &&
 event.notification.data[FCM_MSG])) {
 // Not an FCM notification, do nothing.
 return;
 }
 // Prevent other listeners from receiving the event
 event.stopImmediatePropagation();
 event.notification.close();
 var msgPayload = event.notification.data[FCM_MSG];
 var clickAction = msgPayload['notification']['click_action'];
 if (!clickAction) {
 // Nothing to do.
 return;
 }
 var promiseChain = this.getWindowClient_(clickAction)
 .then(function (windowClient) {
 if (!windowClient) {
 // Unable to find window client so need to open one.
 return self.clients.openWindow(clickAction);
 }
 return windowClient;
 })
 .then(function (windowClient) {
 if (!windowClient) {
 // Window Client will not be returned if it's for a third party origin.
 return;
 }
 // Delete notification data from payload before sending to the page.
 var notificationData = msgPayload['notification'];
 delete msgPayload['notification'];
 var internalMsg = worker_page_message.createNewMsg(worker_page_message.TYPES_OF_MSG.NOTIFICATION_CLICKED, msgPayload);
 // Attempt to send a message to the client to handle the data
 // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
 return _this.attemptToMessageClient_(windowClient, internalMsg);
 });
 event.waitUntil(promiseChain);
 };
 /**
 * @private
 * @param {Object} msgPayload
 * @return {NotificationOptions|undefined}
 */
 SWController.prototype.getNotificationData_ = function (msgPayload) {
 if (!msgPayload) {
 return;
 }
 if (typeof msgPayload.notification !== 'object') {
 return;
 }
 var notificationInformation = Object.assign({}, msgPayload.notification);
 // Put the message payload under FCM_MSG name so we can identify the
 // notification as being an FCM notification vs a notification from
 // somewhere else (i.e. normal web push or developer generated
 // notification).
 notificationInformation['data'] = (_a = {},
 _a[FCM_MSG] = msgPayload,
 _a);
 return notificationInformation;
 var _a;
 };
 /**
 * Calling setBackgroundMessageHandler will opt in to some specific
 * behaviours.
 * 1.) If a notification doesn't need to be shown due to a window already
 * being visible, then push messages will be sent to the page.
 * 2.) If a notification needs to be shown, and the message contains no
 * notification data this method will be called
 * and the promise it returns will be passed to event.waitUntil.
 * If you do not set this callback then all push messages will let and the
 * developer can handle them in a their own 'push' event callback
 * @export
 * @param {function(Object)} callback The callback to be called when a push
 * message is received and a notification must be shown. The callback will
 * be given the data from the push message.
 */
 SWController.prototype.setBackgroundMessageHandler = function (callback) {
 if (callback && typeof callback !== 'function') {
 throw this.errorFactory_.create(errors.codes.BG_HANDLER_FUNCTION_EXPECTED);
 }
 this.bgMessageHandler_ = callback;
 };
 /**
 * @private
 * @param {string} url The URL to look for when focusing a client.
 * @return {Object} Returns an existing window client or a newly opened
 * WindowClient.
 */
 SWController.prototype.getWindowClient_ = function (url) {
 // Use URL to normalize the URL when comparing to windowClients.
 // This at least handles whether to include trailing slashes or not
 var parsedURL = new URL(url).href;
 return self.clients
 .matchAll({
 type: 'window',
 includeUncontrolled: true
 })
 .then(function (clientList) {
 var suitableClient = null;
 for (var i = 0; i < clientList.length; i++) {
 var parsedClientUrl = new URL(clientList[i].url).href;
 if (parsedClientUrl === parsedURL) {
 suitableClient = clientList[i];
 break;
 }
 }
 if (suitableClient) {
 suitableClient.focus();
 return suitableClient;
 }
 });
 };
 /**
 * This message will attempt to send the message to a window client.
 * @private
 * @param {Object} client The WindowClient to send the message to.
 * @param {Object} message The message to send to the client.
 * @returns {Promise} Returns a promise that resolves after sending the
 * message. This does not guarantee that the message was successfully
 * received.
 */
 SWController.prototype.attemptToMessageClient_ = function (client, message) {
 var _this = this;
 return new Promise(function (resolve, reject) {
 if (!client) {
 return reject(_this.errorFactory_.create(errors.codes.NO_WINDOW_CLIENT_TO_MSG));
 }
 client.postMessage(message);
 resolve();
 });
 };
 /**
 * @private
 * @returns {Promise} If there is currently a visible WindowClient,
 * this method will resolve to true, otherwise false.
 */
 SWController.prototype.hasVisibleClients_ = function () {
 return self.clients
 .matchAll({
 type: 'window',
 includeUncontrolled: true
 })
 .then(function (clientList) {
 return clientList.some(function (client) { return client.visibilityState === 'visible'; });
 });
 };
 /**
 * @private
 * @param {Object} msgPayload The data from the push event that should be sent
 * to all available pages.
 * @returns {Promise} Returns a promise that resolves once the message
 * has been sent to all WindowClients.
 */
 SWController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
 var _this = this;
 return self.clients
 .matchAll({
 type: 'window',
 includeUncontrolled: true
 })
 .then(function (clientList) {
 var internalMsg = worker_page_message.createNewMsg(worker_page_message.TYPES_OF_MSG.PUSH_MSG_RECEIVED, msgPayload);
 return Promise.all(clientList.map(function (client) {
 return _this.attemptToMessageClient_(client, internalMsg);
 }));
 });
 };
 /**
 * This will register the default service worker and return the registration.
 * @private
 * @return {Promise} The service worker
 * registration to be used for the push service.
 */
 SWController.prototype.getSWRegistration_ = function () {
 return Promise.resolve(self.registration);
 };
 return SWController;
}(controller_interface));
/* harmony default export */ var sw_controller = (sw_controller_SWController);

//# sourceMappingURL=sw-controller.js.map

// EXTERNAL MODULE: ../app/dist/esm/index.js + 1 modules
var esm = __webpack_require__(6);

// CONCATENATED MODULE: ../messaging/dist/esm/index.js
/* harmony export (immutable) */ __webpack_exports__["registerMessaging"] = registerMessaging;
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




function registerMessaging(instance) {
 var messagingName = 'messaging';
 var factoryMethod = function (app) {
 if (self && 'ServiceWorkerGlobalScope' in self) {
 return new sw_controller(app);
 }
 // Assume we are in the window context.
 return new window_controller(app);
 };
 var namespaceExports = {
 // no-inline
 Messaging: window_controller
 };
 instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(esm["default"]);

//# sourceMappingURL=index.js.map


/***/ })

},[116]);
 } catch(error) {
 throw new Error(
 'Cannot instantiate firebase-messaging.js - ' +
 'be sure to load firebase-app.js first.'
 )
 }


// WEBPACK FOOTER //
// firebase-messaging.js